import React from "react";

import { useQuery } from "@apollo/client";
import { styled } from "@mui/material";
import { useParams } from "react-router-dom";

import { graphql } from "@/gql";

import BodyCompositionSection from "./components/Body-composition/BodyCompositionSection";
import BodyMeasurement from "./components/Body-measurement/BodyMeasurement";
import Calculations from "./components/Calculations/Calculations";
import DietaryHistory from "./components/Dietary-history/DietaryHistory";
import Lifestyle from "./components/Lifestyle/Lifestyle";
import MedicalHistory from "./components/Medical-history/MedicalHistory";
import { Goals } from "./components/Personal-info/components/Goals";
import PersonalInfoSection from "./components/Personal-info/PersonalInfoSection";

const Root = styled("div")(({ theme }) => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing(0, 2, 4, 2),
}));

export const clientProfilePageQuery = graphql(`
  query ClientProfile($id: ID!) {
    client(id: $id) {
      ...PersonalInfoSection
      ...DietaryHistorySection
      ...MedicalHistorySection
      ...LifestyleSection
      ...CalculationsSection
      ...BodyMeasurementSection
      ...BodyCompositionSection
    }

    coachViewer {
      id
      activeClientsLimitReached
    }
  }
`);

export const updateClientProfileMutation = graphql(`
  mutation UpdateClientProfile($input: UpdateClientProfileInput!) {
    updateClientProfile(input: $input) {
      client {
        id
        profile {
          id
        }
      }
    }
  }
`);

const ClientProfilePage: React.FC = () => {
  const { clientId } = useParams<{ clientId: string }>();
  useQuery(clientProfilePageQuery, { variables: { id: clientId ?? "" } });

  return (
    <Root>
      <PersonalInfoSection clientId={clientId ?? ""} />
      <Goals />
      <DietaryHistory clientId={clientId ?? ""} />
      <MedicalHistory clientId={clientId ?? ""} />
      <Lifestyle clientId={clientId ?? ""} />
      <Calculations clientId={clientId ?? ""} />
      <BodyMeasurement clientId={clientId ?? ""} />
      <BodyCompositionSection clientId={clientId ?? ""} />
    </Root>
  );
};

export default ClientProfilePage;
